import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import VueRouter from 'vue-router';
import VeeValidate from 'vee-validate';
import VueGtag from 'vue-gtag';

Vue.use(VueRouter);
Vue.use(VeeValidate);
Vue.use(VueClipboard);
Vue.use(VueGtag, {
  config: {
    id: 'G-0WZGC1HPVT',
  },
});
